import { render, staticRenderFns } from "./modalNovoModelo.vue?vue&type=template&id=1f9a6d34&lang=pug&"
import script from "./modalNovoModelo.vue?vue&type=script&lang=js&"
export * from "./modalNovoModelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports